import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../../utils/request';

const getAcceptanceDelays = createAsyncThunk(
  'acceptanceDelays/getAcceptanceDelays',
  async (formData = {}, { rejectWithValue }) => {
    try {
      const { data } = await authGet('/co/acceptance_delays', { params: { ...formData } });
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export default getAcceptanceDelays;
